import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServerProviderInfo } from 'hooks/useViewer';
import moment from 'moment-jalaali';
export const initialState: ProviderInfo = {
  accessLevel: 'premium',
  membershipDate: '',
  address: '',
  city: '',
  county: '',
  email: '',
  guild: '',
  guildRegisterNumber: '',
  id: '',
  image: '',
  isMobasherPazirande: false,
  latitude: 0,
  longitude: 0,
  managerIdentificationNumber: '',
  birthDate: '',
  managerLastName: '',
  managerMobileNumber: '',
  managerName: '',
  middlemanImage: '',
  middlemanName: '',
  name: '',
  numberOfProducts: 0,
  numberOfRates: 0,
  numberOfUnreadMessages: 0,
  postalCode: '',
  providerType: 1,
  province: '',
  rate: 0,
  status: 'active',
  storePhoneNumber: '',
  orderPermission: false,
  hasNTSWCode: false,
  isNTSWMember: false,
  ranking: 0,
};

const viewerSlice = createSlice({
  name: 'viewer',
  initialState,
  reducers: {
    setViewer(state, action: PayloadAction<{ Result: ServerProviderInfo }>) {
      const { Result } = action.payload;
      state.id = Result.Identification;
      state.address = Result.Address;
      state.city = Result.City;
      state.county = Result.County;
      state.email = Result.Email;
      state.managerName = Result.FirstName;
      state.membershipDate = Result.MembershipDate;
      state.guild = Result.Guild;
      state.birthDate = moment.utc(Result.BirthDate, 'jYYYY/jMM/jDD').format('YYYY/MM/DD');
      state.guildRegisterNumber = Result.GuildRegisterNumber;
      state.latitude = !isNaN(parseFloat(Result.Latitude)) ? parseFloat(Result.Latitude) : 0;
      state.longitude = !isNaN(parseFloat(Result.Longitude)) ? parseFloat(Result.Longitude) : 0;
      state.middlemanImage = Result.MiddlemanImage;
      state.middlemanName = Result.MiddlemanName;
      state.managerMobileNumber = Result.MobileNo;
      state.managerIdentificationNumber = Result.NationalCode;
      state.storePhoneNumber = Result.Phone;
      state.postalCode = Result.PostalCode;
      state.province = Result.Province;
      state.managerLastName = Result.LastName;
      state.image = Result.ProviderImage;
      state.name = Result.ProviderName;
      state.numberOfProducts = Result.ProductCount;
      state.numberOfRates = Result.RateCont;
      state.rate = Result.Satisfaction;
      state.isMobasherPazirande = Result.IsMobasherPazirandeh;
      state.providerType = parseInt(Result.ProviderType, 10) as 1 | 2 | 3;
      state.numberOfUnreadMessages = parseInt(Result.UnreadMessageCount, 10);
      state.status = Result.Status;
      state.accessLevel = Result.AccessLevel;
      state.orderPermission = Result.RequestPermission;
      state.isNTSWMember = Result.NtswMember;
      state.hasNTSWCode = Result.NtswOTPCode;
      state.ranking = Result.Ranking;
    },
    clearViewer(state) {
      state = initialState;
    },
    setViewerHasNTSWCode(state, action: PayloadAction<boolean>) {
      state.hasNTSWCode = action.payload;
    },
  },
});

const { actions, reducer } = viewerSlice;

export const { setViewer, clearViewer, setViewerHasNTSWCode } = actions;

export default reducer;

interface ProviderInfo {
  name: string;
  id: string;
  status: 'active';
  address: string;
  numberOfProducts: number;
  image: string;
  numberOfRates: number;
  rate: number;
  province: string;
  city: string;
  county: string;
  email: string;
  managerName: string;
  managerLastName: string;
  membershipDate: string;
  birthDate: string;
  guild: string;
  guildRegisterNumber: string;
  latitude: number;
  longitude: number;
  middlemanName: string;
  middlemanImage: string;
  managerMobileNumber: string;
  managerIdentificationNumber: string;
  storePhoneNumber: string;
  postalCode: string;
  numberOfUnreadMessages: number;
  isMobasherPazirande: boolean;
  providerType: 1 | 2 | 3;
  accessLevel: 'premium';
  orderPermission: boolean;
  isNTSWMember: boolean;
  hasNTSWCode: boolean;
  ranking: 0 | 1;
}
